import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";

import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { handleApiErrors } from "../../lib/api-errors";
import { makeGetDataAccount } from "../../lib/selector";
import { setDataAccount } from "../client/actions";

import Logo from "../../assets/img/casc_logo.png";
import { formatDate } from "../../util";

import PerfectScrollbar from "react-perfect-scrollbar";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

function PagePreviewPersonal(props) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isCheck, setIsCheck] = useState(false);

  const { _handleToast, dataAccount } = props;

  useEffect(() => {
    if (!dataAccount) {
      history.push("/open-account/check-info");
      return;
    }
  }, []);

  function submit() {
    if (isCheck) return;

    setIsCheck(true);
    const url = `${apiUrl}/openAccount`;

    if (dataAccount?.C_PARAM_PERSONAL) {
      const request = fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(dataAccount?.C_PARAM_PERSONAL),
      });

      request
        .then(handleApiErrors)
        .then((response) => response.json())
        .then((json) => {
          if (json.iRs > 0) {
            // chưa có tài khoản
            let _data = Object.assign({}, dataAccount);
            _data.C_ACCOUNT_NO = json.data[0]?.SOTK;
            dispatch(setDataAccount(_data));

            history.push("/open-account/success");
            _handleToast("Mở tài khoản thành công", "success");
          } else {
            _handleToast(json.sRs, "error");
            setIsCheck(false);
            // let _data = Object.assign({}, dataAccount);
            // _data.C_ACCOUNT_NO = '119CANHKHANH';
            // dispatch(setDataAccount(_data));

            // history.push("/open-account/success");
          }
        })
        .catch((error) => {
          // throw error;
          setIsCheck(false);
        });
    }
  }

  return (
    <>
      <Container>
        <Row>
          <Col lg="10" className="offset-lg-1 px-0">
            <div className="content pt180 fz-16">
              <div
                className="preview-header"
                style={{
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <a href="https://casc.vn/" target="_blank" className="p-0">
                  <img src={Logo} alt="" style={{ height: "60px" }} />
                </a>
                <span
                  style={{
                    fontSize: "28px",
                    fontWeight: "600",
                    lineHeight: "33px",
                    color: "#062046",
                  }}
                >
                  Thông tin Khách hàng và dịch vụ đã đăng ký
                </span>
                {/* <div className="d-grid w-100">
                    <span className="header-first">
                      Hợp đồng mở tài khoản chứng khoán
                    </span>
                    <span className="header-second">
                      (Kiêm Giấy yêu cầu mở tài khoản giao dịch chứng khoán/giao
                      dịch ký quỹ chứng khoán)
                    </span>
                  </div> */}
              </div>
              <PerfectScrollbar
                className="w-100 mb-4 mt-2"
                style={{ height: "calc(100vh - 265px)" }}
              >
                <div className="w-100 p-2">
                  <div className="d-flex flex-column account-form page-preview mt-0">
                    <p className="my-0 fz-18">
                      <b>
                        I.
                        <span style={{ marginLeft: "15px" }}>
                          Thông tin cá nhân
                        </span>
                      </b>
                    </p>
                    <div
                      className="d-grid w-100"
                      style={{
                        gridTemplateColumns: "auto auto auto",
                        gap: "5px",
                        marginLeft: "25px",
                      }}
                    >
                      <div className="text-left" style={{ gridColumn: "1/4" }}>
                        <span>Tên Khách Hàng: </span>
                        <b>
                          {dataAccount?.C_PARAM_PERSONAL?.param?.C_FULL_NAME}
                        </b>
                      </div>

                      <div className="text-left">
                        <span>Số CMND/CCCD: </span>
                        <span>
                          {dataAccount?.C_PARAM_PERSONAL?.param?.C_CARD_ID}
                        </span>
                      </div>
                      <div className="text-left">
                        <span>Ngày cấp: </span>
                        <span>
                          {dataAccount?.C_PARAM_PERSONAL?.param?.C_ISSUE_DATE}
                        </span>
                      </div>
                      <div className="text-left">
                        <span>Nơi cấp: </span>
                        <span>
                          {dataAccount?.C_PARAM_PERSONAL?.param?.C_ISSUE_PLACE}
                        </span>
                      </div>
                      {/* <div className="text-left">
                        <span>Ngày hết hạn: </span>
                        <span>
                          {dataAccount?.C_PARAM_PERSONAL?.param?.C_ISSUE_EXPIRE}
                        </span>
                      </div> */}
                      <div className="text-left">
                        <span>Ngày sinh: </span>
                        <span>
                          {dataAccount?.C_PARAM_PERSONAL?.param?.C_BIRTHDAY}
                        </span>
                      </div>
                      {/* <div className="text-left">
                        <span>Nơi sinh: </span>
                        <span>
                          {dataAccount?.C_PARAM_PERSONAL?.param?.C_PROVINCE}
                        </span>
                      </div> */}
                      <div className="text-left d-flex">
                        <span>Giới tính: </span>
                        <label className="mb-0 d-flex ml-2">
                          Nam
                          <div
                            className={
                              "ml-1 check-label " +
                              (dataAccount?.C_PARAM_PERSONAL?.param
                                ?.C_GENDER === "M"
                                ? "checked"
                                : "")
                            }
                          ></div>
                        </label>
                        <label className="ml-5 mb-0 d-flex">
                          Nữ
                          <div
                            className={
                              "ml-1 check-label " +
                              (dataAccount?.C_PARAM_PERSONAL?.param
                                ?.C_GENDER === "F"
                                ? "checked"
                                : "")
                            }
                          ></div>
                        </label>
                      </div>
                      {/* <div className="text-left">
                        <span>Quốc tịch: </span>
                        <span>VIET NAM</span>
                      </div> */}
                      <div className="text-left" style={{ gridColumn: "1/4" }}>
                        <span>Địa chỉ thường trú/Trụ sở chính: </span>
                        <span>
                          {dataAccount?.C_PARAM_PERSONAL?.param?.C_ADDRESS}
                        </span>
                      </div>
                      <div className="text-left" style={{ gridColumn: "1/4" }}>
                        <span>Địa chỉ liên hệ: </span>
                        <span>
                          {
                            dataAccount?.C_PARAM_PERSONAL?.param
                              ?.C_CONTACT_ADDRESS
                          }
                        </span>
                      </div>

                      <div className="text-left">
                        <span>Di động: </span>
                        <span>
                          {dataAccount?.C_PARAM_PERSONAL?.param?.C_MOBILE}
                        </span>
                      </div>
                      <div className="text-left">
                        <span>Email: </span>
                        <span>
                          {dataAccount?.C_PARAM_PERSONAL?.param?.C_EMAIL}
                        </span>
                      </div>
                    </div>
                    <p className="mb-0 fz-18 mt-3">
                      <b>
                        II.
                        <span style={{ marginLeft: "15px" }}>
                          Dịch vụ đăng ký
                        </span>
                      </b>
                    </p>

                    <table className="table table-bordered mt-3">
                      <tbody>
                        {/* TODO: A. */}
                        <tr>
                          <td
                            className="bg-casc fz-14 font-weight-bold"
                            colSpan={"2"}
                            style={{ padding: "10px 8px" }}
                          >
                            ĐĂNG KÝ MỞ TÀI KHOẢN CHỨNG KHOÁN
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={"2"} style={{ padding: "10px 8px" }}>
                            <span className="fz-14">
                              Khách Hàng tại đây đăng ký và đề nghị CASC mở bổ
                              sung các tài khoản chứng khoán như sau:
                            </span>{" "}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={"2"} className="p-0">
                            <div
                              className="d-grid w-100"
                              style={{ gridTemplateColumns: "auto 150px" }}
                            >
                              <div
                                className="text-center fz-14 text-uppercase font-weight-bold"
                                style={{
                                  border: "1px solid",
                                  borderWidth: "0 1px 0 0",
                                  padding: "10px 8px",
                                }}
                              >
                                Loại tài khoản
                              </div>
                              <div
                                className="text-center fz-14 text-uppercase font-weight-bold "
                                style={{ padding: "10px 8px" }}
                              >
                                Xác nhận
                              </div>
                              <div
                                className="fz-14 text-left"
                                style={{
                                  border: "1px solid",
                                  borderWidth: "1px 1px 0 0",
                                  padding: "10px 8px",
                                }}
                              >
                                Tài Khoản Giao Dịch Ký Quỹ Chứng Khoán <br />
                                (Là tài khoản được dùng để thực hiện các giao
                                dịch ký quỹ chứng khoán)
                              </div>
                              <div
                                className="d-flex justify-content-center align-items-center fz-14"
                                style={{
                                  border: "1px solid",
                                  borderWidth: "1px 0 0 0",
                                }}
                              >
                                <div
                                  className={
                                    "check-label " +
                                    (dataAccount?.C_PARAM_PERSONAL?.param
                                      ?.C_OPEN_MARGIN === "1"
                                      ? "checked"
                                      : "")
                                  }
                                ></div>
                              </div>
                            </div>
                          </td>
                        </tr>
                        {/* TODO: B. */}
                        <tr>
                          <td
                            className="bg-casc fz-14 font-weight-bold"
                            colSpan={"2"}
                            style={{ padding: "10px 8px" }}
                          >
                            ĐĂNG KÝ SỬ DỤNG DỊCH VỤ GIAO DỊCH QUA ĐIỆN THOẠI
                          </td>
                        </tr>
                        <tr>
                          <td
                            className="fz-14"
                            colSpan={"2"}
                            style={{ padding: "10px 8px" }}
                          >
                            <b>Số điện thoại đăng ký</b>: Là số điện thoại di
                            động của Khách Hàng nêu tại Mục I - Thông tin cá
                            nhân
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={"2"} className="p-0">
                            <div
                              className="d-grid w-100"
                              style={{ gridTemplateColumns: "auto 150px" }}
                            >
                              <div
                                className="text-center fz-14 text-uppercase font-weight-bold"
                                style={{
                                  border: "1px solid",
                                  borderWidth: "0 1px 0 0",
                                  padding: "10px 8px",
                                }}
                              >
                                Nội dung
                              </div>
                              <div
                                className="text-center fz-14 text-uppercase font-weight-bold"
                                style={{ padding: "10px 8px" }}
                              >
                                Xác nhận
                              </div>
                              <div
                                className="fz-14 text-left"
                                style={{
                                  border: "1px solid",
                                  borderWidth: "1px 1px 0 0",
                                  padding: "10px 8px",
                                }}
                              >
                                Đăng ký thực hiện giao dịch tới hệ thống điện
                                thoại cố định của CASC.
                                <span className="fs-i">
                                  Các loại giao dịch đăng ký thực hiện bao gồm:
                                  (i) Nhận thông tin, thông báo; (ii) Đặt lệnh
                                  giao dịch chứng khoán và các giao dịch chuyển
                                  tiền giữa các tiểu khoản của Khách Hàng tại
                                  CASC; (iii) Ứng trước tiền bán chứng khoán;
                                  (iv) Thực hiện quyền mua chứng khoán; (v) Nhận
                                  mật khẩu, thông tin xác thực.
                                </span>
                              </div>
                              <div
                                className="d-flex justify-content-center align-items-center fz-14 py-1"
                                style={{
                                  border: "1px solid",
                                  borderWidth: "1px 0 0 0",
                                }}
                              >
                                <div
                                  className={
                                    "check-label " +
                                    (dataAccount?.C_PARAM_PERSONAL?.param
                                      ?.C_FOLLOW_TRADING === "1"
                                      ? "checked"
                                      : "")
                                  }
                                ></div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </PerfectScrollbar>

              {/* <hr /> */}
              <Row className="justify-content-center mt-2 mb-4">
                <Button
                  onClick={() => history.goBack()}
                  className="prev-page"
                  style={{
                    borderRadius: "25px",
                    boxShadow: "0px 4px 2px rgb(0 0 0 / 10%)",
                  }}
                >
                  Quay lại
                </Button>
                <Button
                  className="btn-next"
                  onClick={submit}
                  disabled={isCheck}
                >
                  TIẾP TỤC
                </Button>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  const getDataAccount = makeGetDataAccount();

  return {
    dataAccount: getDataAccount(state),
  };
};

export default connect(mapStateToProps)(PagePreviewPersonal);
